import React from 'react';
import { arrayOf, number, oneOfType, string } from 'prop-types';
import SharedLogoLoader from '../../../../../shared/LogoLoader/LogoLoader';
import { useLocale } from '../../hooks';
import allMessages from './messages';

const LogoLoader = ({ label, phrases, ...props }) => {
  const { messages } = useLocale(allMessages);

  return (
    <SharedLogoLoader {...props} label={label || messages.loading} phrases={phrases || messages.phrases} />
  );
};

LogoLoader.propTypes = {
  size: oneOfType([number, string]),
  label: string,
  phrases: arrayOf(string),
  className: string
};

export default LogoLoader;
